module.exports = __webpack_public_path__ + "img/app_messenger_text_th.030652c4.png";